<template>
  <NuxtLayout>
    <div class="login__Content">
      <div class="login__FormWrapper">
        <div class="login__FormInner">
          <h1 v-text="page.title" />
          <p>{{ $t('login.notAMember') }} <nuxt-link :to="link('Registration')" class="button__Text--Underline">{{ $t('login.createYourAccount') }}</nuxt-link></p>

          <div class="customError__Wrapper">
            <div class="customError" v-if="userDoesNotExist">
              <p v-text="$t('loyaltyErrors.error112')" />
            </div>
            <div class="customError" v-if="invalidCredentials">
              <p v-text="$t('formErrors.no_active_account')" />
            </div>
            <div v-if="customError && Object.keys(customError).length" class="customError">
              <p v-text="$t(`loyaltyErrors.error${ customError.code }`)" />
            </div>
          </div>
  
          <form @submit.prevent="submitForm" class="absoluteLabelsForm">
            <TextField v-model="form.email" :label="$t('forms.email')" type="email" :errors="formErrors?.field_errors?.email" />
            <TextField class="form__PasswordField form__PasswordFirstField" v-model="form.password" :label="$t('forms.password')" type="password" :errors="formErrors?.field_errors?.password">
              <template #append>
                <button type="button" @click="togglePasswordVisibility">
                  <Icon name="password" />
                  <Icon name="password-hide" />
                </button>
              </template>
            </TextField>
            <div class="login__ForgotPasswordWrapper">
              <NuxtLink class="button__Text--Underline" :to="link('ForgottenPassword')">{{ $t('login.forgotPassword') }}</NuxtLink>
            </div>
            <Button class="login__FormSubmitButton" medium full-width @click="submitLogin" :disabled="dataFetchInProgress">{{ $t('login.login') }}</Button>
          </form>
        </div>
      </div>
      <div class="login__ImageWrapper">
        <FlarePicture :src="{ 1920: { src: page.image, width: 1100, height: 1500, size: 'both', crop: 'fill' } }" :alt="page.image" />
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });

  const props = defineProps({
    page: {
      type: Object
    }
  })
  
  const { link } = useSetup();
  const { lang } = useLanguage();
  const { login } = useAuth('aminess');

  const dataFetchInProgress = ref(false);
  const formErrors = ref(null);
  const userDoesNotExist = ref(false);
  const invalidCredentials = ref(false);
  const { customError, setCustomError } = useCustomFormErrors(formErrors.value);
  const form = ref({
    email: '',
    password: ''
  });

  async function submitLogin() {
    dataFetchInProgress.value = true;
    userDoesNotExist.value = false;
    invalidCredentials.value = false;
    try {
      await login({ email: form.value.email, password: form.value.password }, {
        headers: {
          'Application-Origin': 'SHAPE-WEB'
        }
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'login',
        'method': 'email',
      });
      await navigateTo(link('LoyaltyDashboard'));
    } catch(error) {
      console.log(error)
      if (error.data) formErrors.value = error.data;

      if (error.response?._data?.errors && error.response?._data?.errors['profile.not_found']) {
        userDoesNotExist.value = true;
      }

      if (error.response?._data?.errors && error.response?._data?.errors['loyalty.invalid_credentials']) {
        invalidCredentials.value = true;
      }

      setCustomError(formErrors.value);
    }
    dataFetchInProgress.value = false;
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_login.scss');
</style>